import styled from 'styled-components'
import colors from '../../../configuration/colors'
import SkillsIcon from '../../../static/images/Skills/skills_icon_large.svg'
import { H1, H3, H5 } from '../../styled/typography/typography'

const ModalContainer = styled.div`
  background: ${colors.smoke};
  height: auto;
  width: 740px;
  padding-bottom: 30px;
`

const H1Skills = styled(H1).attrs({
  as: 'h1'
})`
  padding-left: 60px;
  background: no-repeat url(${SkillsIcon});
  background-size: contain;
  width: fit-content;
  margin: 0 auto 30px;
`

const H3Skills = styled(H3).attrs({
  as: 'h3'
})`
  margin-left: 10px;
`

const H5Skills = styled(H5).attrs({
  as: 'h5'
})`
  margin: 6px 0 0;
`

const ModalSkillCard = styled.div`
  position: relative;
  margin-bottom: 30px;
  padding: 33px 35px;
  background: ${colors.white};
  border-radius: 20px;
  box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
`

const ActionButtonsWrapper = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  right: -86px;
  width: 86px;
  height: 100%;
  padding-left: 12px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  opacity: ${props => (props.visible ? '1.0' : '0')};
  cursor: default !important;
`

const ButtonsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
`

const LoadingContainer = styled.div`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
  margin-left: 30px;
  margin-right: 10px;
  margin=bottom: 0;
  min-height: 40px;
`

export {
  ModalContainer,
  H1Skills,
  H3Skills,
  H5Skills,
  ModalSkillCard,
  ActionButtonsWrapper,
  ButtonsContainer,
  LoadingContainer
}
